import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TaobaoSquareFilledSvg from "@ant-design/icons-svg/es/asn/TaobaoSquareFilled";
import AntdIcon from "../components/AntdIcon";
var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TaobaoSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(TaobaoSquareFilled);